import React from 'react'

const Icon = ({className}) => {
  return (
<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 14 14" className={className}>
  <defs>
    <clipPath id="clip-Login">
      <rect width="14" height="14"/>
    </clipPath>
  </defs>
  <g id="Login" clip-path="url(#clip-Login)">
    <g id="noun-login-4700279" transform="translate(-18 -17.243)">
      <path id="Path_6543" data-name="Path 6543" d="M28.409,18.058A6.2,6.2,0,0,0,22.5,20.55a.776.776,0,0,0,1.256.911,4.65,4.65,0,1,1,0,5.464.776.776,0,0,0-1.252.917,6.2,6.2,0,0,0,11.213-3.949A6.554,6.554,0,0,0,28.409,18.058Z" transform="translate(-2.699)" fill="#6a7ab2" stroke="#fff" stroke-width="0.3"/>
      <path id="Path_6544" data-name="Path 6544" d="M19,37.959a.775.775,0,0,0,.775.775H24.89l-.816.8a.775.775,0,0,0,1.089,1.1l1.781-1.765a1.289,1.289,0,0,0,0-1.833l-1.788-1.767a.775.775,0,0,0-1.089,1.1l.823.806H19.775A.775.775,0,0,0,19,37.959Z" transform="translate(0 -13.764)" fill="#6a7ab2" stroke="#fff" stroke-width="0.3"/>
    </g>
  </g>
</svg>
  )
}

export default Icon